/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Volver',
    SCAN_QR_CODE: 'Escanear el código QR'
  },
  ERRORS: {
    GET_DOCUMENT: 'No se ha podido obtener el documento.',
    INVALID_CODE: 'Código no válido',
    VALIDATING_CODE: 'No se ha podido validar el código.'
  },
  LABELS: {
    DELIVERY_ORDER: 'Pedido de entrega',
    ERROR: 'Error',
    OR: 'O',
    PACKAGE: 'Paquete',
    TRACKING_OR_CODE: 'Número de seguimiento o código de paquete'
  }
};
